import { useField } from 'formik';
import { ResponseErrorType } from '@/types/sharedTypes';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { DataPickerType, DatePicker, DateValueType } from '../DatePicker/DatePicker';

type FormikDataPickerType = Omit<DataPickerType, 'value' | 'apiError'> & {
  name: string;
  apiError?: ResponseErrorType;
};

export const FormikDatePicker = ({ name, apiError, ...rest }: FormikDataPickerType) => {
  const [field, meta, { setValue }] = useField(name);
  const { error, apiError: apiErrorMessage } = getFieldError(name, meta, apiError);

  const changeHandler = (value: DateValueType) => {
    setValue(value);
  };

  return <DatePicker {...field} onChange={changeHandler} error={error} apiError={apiErrorMessage} {...rest} />;
};
